import React, { Component } from 'react';
import {
    Container, Segment, Header, Table, Message, Button, Grid
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import _ from 'underscore';
import { connect } from 'react-redux';
import ElogCompanyFilter from '../../component/elog/elog_company_filter';

import {
    getElogList,
    getElogPdfUrl,
} from '../../actions';

class ElogRecordPage extends Component {
    state = {
        selectedCompany: this.props.user.companies[0].companyId || null,
    }

    componentDidMount() {
        this.fetchElogRecords();
    }

    componentDidUpdate(prevProps, prevState) {
        const { contactNoVerified } = prevProps;
        if (contactNoVerified !== this.props.contactNoVerified || prevState.selectedCompany != this.state.selectedCompany) {
            this.fetchElogRecords();
        }
    }

    fetchElogRecords(){
        const {nric, accessToken, companies} = this.props.user;
        const companyId = this.state.selectedCompany ? this.state.selectedCompany : companies[0].companyId
        this.props.getElogList(nric, accessToken, companyId);
    }

    handleDownloadElogPdf = (elogId, policyNo, filename) => {
        if (this.props.selectedElogId !== elogId) {
            const {accessToken} = this.props.user;
            this.props.getElogPdfUrl({eLoG_ID: elogId, policyNo, filename, accessToken}, (result, error) => {
                console.log(result, error);
                if (result) {
                    // open result url in a new tab using javascript
                    window.open(result.data.data.PDF_URL,'_blank');
                }
            });
        }
    }

    updateCompanySelected = (companyId) => {
        this.setState({
            selectedCompany: companyId, 
        });
    }
    render() {
        // console.log('-->', this.props.elogListData);
        return (
            <Container fluid>
                <Header as='h2' attached='top' block>
                    Letter of Guarantee (eLOG) Records
                    <Header.Subheader>
                        You may share or forward the approved LOG to the hospital
                    </Header.Subheader>
                </Header>
                <Segment>
                <Grid columns={3}>
                        {this.props.user.companies.length > 1 &&
                        <Grid.Column>
                            <ElogCompanyFilter
                                user={this.props.user}
                                selectedCompany={this.state.selectedCompany}
                                updateCompanySelected={this.updateCompanySelected}
                            />
                        </Grid.Column>}
                    </Grid>
                    <Table celled selectable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Reference Number</Table.HeaderCell>
                                <Table.HeaderCell>Admission Date</Table.HeaderCell>
                                <Table.HeaderCell>Submission Date</Table.HeaderCell>
                                <Table.HeaderCell>Clinic / Hospital / Provider</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                                <Table.HeaderCell>Remarks</Table.HeaderCell>
                                <Table.HeaderCell>Document</Table.HeaderCell>
                                <Table.HeaderCell>Chat</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                        {
                            _.map(this.props.elogListData, (elog, index) => {
                                const {files, policy_no} = elog;
                                return (
                                    <Table.Row key={index}>
                                        <Table.Cell>{elog.eLoG_id}</Table.Cell>
                                    <Table.Cell>{Moment(elog.dateFrom).format('DD MMM YYYY')}</Table.Cell>
                                        <Table.Cell>{Moment(elog.createdon).format('DD MMM YYYY')}</Table.Cell>
                                        <Table.Cell>{elog.hospital}</Table.Cell>
                                        <Table.Cell>{elog.status}</Table.Cell>
                                        <Table.Cell>{elog.remarks}</Table.Cell>
                                        <Table.Cell>
                                            <Button
                                                onClick={() => this.handleDownloadElogPdf(elog.eLoG_id, policy_no, files[0])}
                                                disabled={(files.length === 0)}
                                            >
                                                View eLOG
                                            </Button>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Link to={`/app/askjoey?type=elog&id=${encodeURIComponent(elog.eLoG_id)}`}>
                                                <Button>
                                                    Ask Joey
                                                </Button>
                                            </Link>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })
                        }
                        {
                            (this.props.elogListData.length === 0) ?
                            (
                                <Table.Row>
                                    <Table.Cell colSpan={6}>
                                        <Message info>
                                            There is no Elogs records.
                                        </Message>
                                    </Table.Cell>
                                </Table.Row>
                            )
                            : null
                        }
                        </Table.Body>
                    </Table>
                </Segment>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        elogListData: state.elogs.listData,
        selectedElogPdfUrl: state.elogs.selectedElogPdfUrl,
        selectedElogId: state.elogs.selectedElogId,
        user: state.user.user,
        contactNoVerified: state.otp.contactNoVerified,
    };
}

export default connect(mapStateToProps, {
    getElogList,
    getElogPdfUrl,
})(ElogRecordPage);
